import { render, staticRenderFns } from "./ComparisonIcon.vue?vue&type=template&id=cdf75d2e&"
import script from "./ComparisonIcon.vue?vue&type=script&lang=js&"
export * from "./ComparisonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports